const SET_IMAGES = 'SET_IMAGES';

const setImages = images => ({
  type: SET_IMAGES,
  payload: {
    ...images
  }
});

export { SET_IMAGES, setImages };
